import { useLocation, useNavigate, useParams } from "@tanstack/react-router";
import { Receipt } from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export function EndOfDaySelect() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams({ from: "/_authenticated/locations/$id" });

  // More reliable way to determine the current report type
  const currentValue = location.pathname.includes("business-report")
    ? "business-report"
    : "employee-report";

  return (
    <Select
      onValueChange={(value) =>
        navigate({ to: `/locations/${params.id}/end-of-day/${value}` })
      }
      value={currentValue}
    >
      <SelectTrigger className="w-80 justify-start gap-2">
        <Receipt className="text-foreground size-5" />
        <SelectValue placeholder="Select report type" />
        <div className="flex-1" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="employee-report">Employee Report</SelectItem>
        <SelectItem value="business-report">Business Report</SelectItem>
      </SelectContent>
    </Select>
  );
}
